import { useEffect } from 'react'
import { useRouter } from 'next/router'

import { getLocaleFromPath } from '@lib/i18n'

const useChangeLanguageFromPath = (i18n: any) => {
  const router = useRouter()

  useEffect(() => {
    const locale = getLocaleFromPath(router.pathname)
    i18n.changeLanguage(locale)
  }, [i18n, router])
}

export { useChangeLanguageFromPath }
